import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'network-dashboard-rollup-table',
  template: require('./network-dashboard-rollup-table.component.html'),
  styles: [require('./network-dashboard-rollup-table.component.scss')],
})
export class NetworkDashboardRollupTableComponent {
  @Input() groupingData;
  @Input() sort$;
  @Input() hoveredVizBar;
  @Output() sortEmitter = new EventEmitter();
  @Output() rowEmitter = new EventEmitter();
  @Output() hoverEmitter = new EventEmitter();

  emitSort($event): void {
    this.sortEmitter.emit({ key: $event });
  }

  emitRowClick($event): void {
    this.rowEmitter.emit($event);
  }

  emitRowHover($event) {
    this.hoverEmitter.emit($event);
  }
}
